import { Button, Col, Input, Radio, Row, Tooltip } from "antd"
import {
  DeleteOutlined
} from "@ant-design/icons";

const QuizQuestionOption = ({
  index: idx,
  option,
  optionFields,
  handleCorrectRadio,
  handleOptionChange,
  handleRemoveOption,
}) => {
  return (
    <Row
      key={idx}
      align="middle"
      style={{
        maxWidth: 700,
        marginBottom: 16,
        fontSize: 16,
      }}
    >
      <Col flex="none">
        <Radio
          checked={option?.isCorrect}
          onChange={() => handleCorrectRadio(idx)}
          style={{ fontSize: 16 }}
        />
      </Col>
      <Col flex="auto" style={{ paddingLeft: 8 }}>
        <Input
          placeholder={`Option ${idx + 1}`}
          value={option?.text}
          onChange={(e) => handleOptionChange(idx, "text", e.target.value)}
          style={{ fontSize: 16, padding: "6px 12px" }}
        />
      </Col>
      <Col flex="none">
        <Tooltip title="Remove option">
          <Button
            icon={<DeleteOutlined />}
            danger
            size="middle"
            disabled={optionFields.length <= 2}
            onClick={() => handleRemoveOption(idx)}
            style={{ marginLeft: 12 }}
          />
        </Tooltip>
      </Col>
    </Row>
  );
};

export default QuizQuestionOption;